module.exports = __webpack_public_path__ + "img/mini-logo.3628cbc3.png";